module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"save":"Save","cancel":"Cancel","vacancyEditing":"Edit job"}}')
  delete Component.options._Ctor
}
